import React from 'react';
import PropTypes from 'prop-types';

const BenefitsSection = ({ title, benefits, src }) => {
  return (
    <div className="bg-white lg:text-left px-8 py-14 md:px-24 xl:px-36 2xl:px-60 lg:py-16 w-full">
      <div className="flex flex-col lg:flex-row justify-between items-center mx-auto lg:flex-row-reverse">
        <div className="
            sm:flex-shrink-0 flex flex-col items-center justify-center lg:w-1/2 lg:pl-8 mb-8
          ">
          <h2 className="text-[20px] font-semibold text-[#1C2938] mb-5">
            {title}
          </h2>
          <div className="
            flex flex-1 flex-col space-y-6 lg:space-y-0
            divide-y divide-gray-300 max-w-[635px]
          ">
            <ul className="list-disc pl-8">
              {benefits.map((benefit, index) => (
                <li className="py-2" key={index}>{benefit}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="lg:w-1/2 flex">
          <img
            src={src}
            alt="Benefits Visual"
            className="w-full rounded-[25px]"
          />
        </div>

      </div>
    </div>
  );
};

BenefitsSection.propTypes = {
  title: PropTypes.string,
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      icon: PropTypes.string,
    })
  ),
  src: PropTypes.string,
};

export default BenefitsSection;
